import { render, staticRenderFns } from "./ProgrammeInfoView.vue?vue&type=template&id=1c805d5d&"
import script from "./ProgrammeInfoView.vue?vue&type=script&lang=js&"
export * from "./ProgrammeInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports